import axios from "axios";

function useFonts() {

    const fonts = [
        {url: './fonts/Geologica-Medium.ttf', weight: 'normal'},
        {url: './fonts/Geologica-Thin.ttf', weight: 100},
        {url: './fonts/Geologica-ExtraLight.ttf', weight: 200},
        {url: './fonts/Geologica-Light.ttf', weight: 300},
        {url: './fonts/Geologica-Regular.ttf', weight: 400},
        {url: './fonts/Geologica-Medium.ttf', weight: 500},
        {url: './fonts/Geologica-SemiBold.ttf', weight: 600},
        {url: './fonts/Geologica-Bold.ttf', weight: 700}
    ]

    function setupFont() {
        fonts.forEach(async (font) => {
            let name = font.url.replaceAll("./", "").replaceAll("/", "-").replaceAll(".ttf", "");
            await cacheFont(name, font.url, font.weight);
        })
    }

    async function cacheFont(fontName, fontUrl, weight) {
        if (localStorage.getItem(fontName)) {
            loadFontFromCache(fontName, weight);
        } else {
            const font = await fetchFont(fontUrl);
            saveFontToCache(font, fontName, () => {
                loadFontFromCache(fontName, weight);
            });
        }
    }

    async function fetchFont(url) {
        const responseA = await axios.get(url, {responseType: 'blob'}).then((response) => {
            return response;
        }).catch((e) => console.log(e));
        return responseA.data;
    }

    function saveFontToCache(fontBlob, fontName, callback) {
        const reader = new FileReader();
        reader.onload = function () {
            localStorage.setItem(fontName, reader.result);
            callback()
        };
        reader.readAsDataURL(fontBlob);
    }

    function loadFontFromCache(fontName, weight) {
        const fontData = localStorage.getItem(fontName);
        const fontFace = new FontFace('Geologica', `url(${fontData})`, {
            weight: weight,
            style: 'normal'
        });
        document.fonts.add(fontFace);
        fontFace.load();
    }

    setupFont();

}

export {useFonts};